/**
 *   Created by FANGlh on 2019/1/19 12:32.
 *   Desc: 学生请接单列表
 */

import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './LeaveListPage.css'
import '../../style/css/app-gloal.css'
import {Button,Icon,Input,List,Skeleton} from 'antd';
import InfiniteScroll from 'react-infinite-scroller'
import LoadingMore from "../../components/LoadingMore";
import {fetchPost,fetchGet} from "../../utils/fetchRequest";
import {API,_baseURL} from "../../configs/api.config";
import {connect} from 'react-redux'
import LeaveItem from './LeaveItem';
import RefreshLayout from "../../components/RefreshLayout";
import {saveListState} from "../../redux/actions/listState";
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import {Toast} from 'antd-mobile';
import nodata_img from '../../style/imgs/no_data.png';

let LEAVE_LIST_URL = ''
let mPageIndex = 0

class LeaveListPage extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'LeaveListPage',
            detailVisible: false,
            pageIndex:1,
            pageSize:10,
            listItem:null,
            index:null,
            role:this.props.match.params.role,
            data:[],

            isRefreshing: false,
            isLoading: true
        };
    }

    componentWillMount(){
        document.title ="学生请假条";
    }

    componentDidMount(){
        console.log('listState', this.props.listState)
        if (this.props.listState && !isObjEmpty(this.props.listState.listData)) {
            this.setState({
                data: this.props.listState.listData,
                isLoading: false,
            }, () => {
                ReactDOM.findDOMNode(this.container).scrollTop = this.props.listState.scrollTop
            })
            mPageIndex = this.props.listState.pageIndex
        } else {
            // Toast.loading('数据加载中...', 0)
            mPageIndex = 0
            this.loadMoreAction();
        }
    }



    render(){
        return <div   style={{background: '#F2F2F2'}}>

                    <RefreshLayout
                        refreshing={this.state.isRefreshing}
                        ref={el => {
                            this.container = el
                        }}
                        onRefresh={this.loadMoreAction}>
                        {
                            this.state.data.length > 0 ?
                                this.state.data.map((itemdata,index) =>  <LeaveItem itemdata={itemdata} role={this.state.role} index = {index} onItemClick={this.onItemClick.bind(this)}></LeaveItem>)
                                :
                                <List dataSource={this.state.data}
                                      renderItem={(itemdata,index) =>(
                                          <List.Item  >
                                              <LeaveItem itemdata={itemdata} role={this.state.role} index = {index} onItemClick={this.onItemClick.bind(this)}></LeaveItem>
                                          </List.Item>
                                      )}/>
                        }
                        {/*<Skeleton loading={this.state.isLoading} active paragraph={{rows: 3}}>*/}
                            {/*{this.state.data.map((itemdata,index) =>  <LeaveItem itemdata={itemdata} role={this.state.role} index = {index} onItemClick={this.onItemClick.bind(this)}></LeaveItem>*/}
                            {/*)}*/}
                        {/*</Skeleton>*/}
                    </RefreshLayout>

                    {
                        this.state.role=="teacher"?(""):(<Icon type="plus-circle" theme='filled' className='common-add-icon'
                                                               onClick={this.onAddAction} />)
                    }
        </div>
    }


    onItemClick = (index) => {
        console.log('onItemClick',index)
        console.log('listState', ReactDOM.findDOMNode(this.container).scrollTop)
        saveListState({
            scrollTop: ReactDOM.findDOMNode(this.container).scrollTop,
            listData: this.state.data,
            pageIndex: mPageIndex,
            itemIndex: index,
        })()
    }
    loadMoreAction=()=> {
        mPageIndex++;
        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {
        }
        setTimeout(() => {
            console.log("this.state.role",this.state.role)
            if (this.state.role === "teacher") {
                fetchPost(API.leaveListTeacher, {
                    teacherId: this.props.userInfo.user.userFunId,
                    pageIndex:mPageIndex,
                    pageSize: this.state.pageSize
                }).then((response) => {
                    if(response.data.length>0){
                        for (let i = 0; i < response.data.length; i++) {
                            let model = {
                                lvId:response.data[i].lvId,
                                title: response.data[i].lvTitle,
                                endTime: response.data[i].endDate,
                                startTime: response.data[i].startDate,
                                content: response.data[i].lvDetails,
                                enclosure:response.data[i].enclosure,
                                leaveMessages:response.data[i].oaLeaveReplyDOS
                            };
                            this.state.data.push(model);
                        }
                        this.setState({
                            data: this.state.data
                        })
                    }else{

                    }
                    this.setState({
                        isRefreshing: false,
                        isLoading: false
                    })
                }).catch((error) => {
                    console.log("error:" + JSON.stringify(error));
                    this.setState({
                        isRefreshing: false,
                        isLoading: false
                    })
                    Toast.info(error, 2)
                })
            }
            if (this.state.role === "parent") {
                fetchPost(API.leaveListParent, {
                    stuId: this.props.userInfo.user.student.stuId,
                    pageIndex: mPageIndex,
                    pageSize: this.state.pageSize
                }).then((response) => {
                    if(response.data.length>0){
                        response.data.forEach((itemdata,index)=>{
                            let model = {
                                lvId:itemdata.lvId,
                                title: itemdata.lvTitle,
                                endTime: itemdata.endDate,
                                startTime: itemdata.startDate,
                                content: itemdata.lvDetails,
                                enclosure:itemdata.enclosure,
                                leaveMessages:itemdata.oaLeaveReplyDOS
                            };
                            this.state.data.push(model);
                        })
                       this.setState({
                           data:this.state.data
                       },function () {
                           console.log('data',this.state.data)
                       })
                    }else{

                    }
                    this.setState({
                        isRefreshing: false,
                        isLoading: false
                    })
                }).catch((error) => {
                    console.log("error:" + JSON.stringify(error));
                    this.setState({
                        isRefreshing: false,
                        isLoading: false
                    })
                    Toast.info(error, 2)
                })
            }
        }, 500)

    }
/*    getListData= () =>{
        if(mPageIndex == 0){
            mPageIndex = 1
            this.getLeaveListData()
        }else {
            mPageIndex++;
            this.loadMoreAction()
        }
    }*/
    onAddAction=()=>{
        this.props.history.push("/leaveAdd/");
    }
    onItemOnClick=(index,item)=>{
        console.log("onItemOnClick()",JSON.stringify(item));
        this.props.history.push('/leavedetail/' +this.state.role +'/'+ item.lvId)
        return;
        this.setState({
            detailVisible: true,
            listItem:item,
            index:index
        })

    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LeaveListPage)